export default {
  props: {
    /**
      * URL serving as an endpoint used for requests (defaults to mock api)
      */
    url: {type: String, default: 'http://localhost:3000'}
  }
};
